import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import StringProperty from './property-type/string';
import ListProperty from './property-type/list';
import * as S from './styles';
import { CorePropertiesType, CoreProperty } from './types';

type PropertyProps = {
  property: CoreProperty & { pathName?: string };
};

const Property = ({ property }: PropertyProps) => {
  const { t } = useAppContext();
  switch (property.__typename) {
    case 'PropertyString':
      return <StringProperty property={property} />;
    case 'PropertyList':
      return <ListProperty property={property} />;
    case 'PropertyBoolean':
      return (
        <>
          {t(
            'product',
            property.prettyTable !== 'false'
              ? 'property.boolean-yes'
              : 'property.boolean-no'
          )}
        </>
      );
    default:
      return <>{property.prettyTable}</>;
  }
};

type Props = {
  className?: string;
  properties: CorePropertiesType;
};

const CorePropertiesTable = ({ className, properties }: Props) => (
  <S.PropertyTable className={className}>
    <S.TableBody>
      {properties ? (
        properties.map(property => {
          const { id, name, prettyTable } = property;

          if (prettyTable === null) {
            return null;
          }

          return (
            <S.TableRow key={String(id)}>
              <S.TableHeader scope="row">{name}</S.TableHeader>
              <S.TableCell>
                <Property property={property} />
              </S.TableCell>
            </S.TableRow>
          );
        })
      ) : (
        <S.TableRow>
          <S.TableCell>
            <S.PlaceholderProperty />
          </S.TableCell>
        </S.TableRow>
      )}
    </S.TableBody>
  </S.PropertyTable>
);

export default CorePropertiesTable;
